<input class="form-control" :type="type" v-model="inputValue" @blur="blur">